export default __webpack_public_path__ + "static/img_10-da22d9d6ea6ba29f5d1988988ee228e5.png";